import React from "react";
import PlayStoreLogo from "../Assets/img/download-app/play-store.svg";
import FrameImg from "../Assets/img/frame.png";

const DownloadApp = () => {
  return (
    <>
      <section className="download-app-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="download-content">
                <h3 className="d-title">
                  Download the app from Google Play Store
                </h3>
                <div className="download-app">
                  <a href="#" target="_blank">
                    <img src={PlayStoreLogo} alt="#" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 order-top">
              <div className="download-img">
                <img src={FrameImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DownloadApp;
